<template>
  <RevContainer>
    <h2 class="text-static-default-hi heading-1 mb-4 flex md:justify-center">
      {{ i18n(translations.title) }}
    </h2>

    <div v-if="!pending && policies && eligibleInsurances">
      <PoliciesAndEligibleInsurances
        v-if="!isEmpty(policies)"
        :eligible-insurances
        :policies
      />

      <EligibleInsurances
        v-if="isEmpty(policies) && !isEmpty(eligibleInsurances)"
        :eligible-insurances
      />

      <NoPoliciesOrEligibleInsurances
        v-if="isEmpty(policies) && isEmpty(eligibleInsurances)"
      />
    </div>
  </RevContainer>
</template>

<script setup lang="ts">
import { useAsyncData } from '#imports'
import { computed } from 'vue'

import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'
import { isEmpty } from '@ds/utils/isEmpty'

import translations from './ServicesHub.translations'
import EligibleInsurances from './pages/EligibleInsurances/EligibleInsurances.vue'
import NoPoliciesOrEligibleInsurances from './pages/NoPoliciesOrEligibleInsurances/NoPoliciesOrEligibleInsurances.vue'
import PoliciesAndEligibleInsurances from './pages/PoliciesAndEligibleInsurances/PoliciesAndEligibleInsurances.vue'

const i18n = useI18n()
const $httpFetch = useHttpFetch()

const key = getAsyncDataKey('policiesAndEligibleInsurances')

const { data, pending } = await useAsyncData(key, () => {
  return Promise.all([
    $httpFetch('/api/insurance/v1/services-hub/policies', {
      method: 'GET',
    }),
    $httpFetch('/api/insurance/v1/services-hub/post-purchase-eligible-offers', {
      method: 'GET',
    }),
  ])
})

const policies = computed(() => data.value?.[0])
const eligibleInsurances = computed(() => data.value?.[1])
</script>
